import Glide from '../../../../Public/Frontend/node_modules/@glidejs/glide';
import PhotoSwipeLightbox from '../../../../Public/Frontend/node_modules/photoswipe/dist/photoswipe-lightbox.esm.js';
import PhotoSwipe from '../../../../Public/Frontend/node_modules/photoswipe/dist/photoswipe.esm.js';

;(function () {
    let sliders = document.querySelectorAll('.image-slider .glide');
    if (!sliders.length) {
        return;
    }

    sliders.forEach(el => {
        if (el.querySelectorAll('.glide__slide').length < 2) {
            return;
        }

        let glide = new Glide(el, {
            type: 'carousel',
            perView: 5,
            gap: 15,
            autoplay: 3000,
            hoverpause: true,
            bound: true,
            focusAt: 0,
            breakpoints: {
                600: {
                    perView: 1
                },
                800: {
                    perView: 2
                },
                1300: {
                    perView: 3
                },
                1921: {
                    perView: 4
                }
            }
        });

        glide.on(['build.after'], function () {
            const lightbox = new PhotoSwipeLightbox({
                gallery: el.querySelector('.glide__slides'),
                mainClass: 'image-slider-lightbox',
                children: '.glide__slide a',
                pswpModule: PhotoSwipe,
                showHideAnimationType: 'zoom',
                initialZoomLevel: 'fit',
                showAnimationDuration: 1000,
                hideAnimationDuration: 1000,
                counter: false
            });

            lightbox.init();

            lightbox.on('openingAnimationStart', () => {
                glide.pause();
            });

            lightbox.on('closingAnimationEnd', () => {
                glide.play();
            });

            document.addEventListener('click', function (e) {
                let target = e.target;
                if (target.classList.contains('pswp__button--arrow--next')) {
                    glide.go('>');
                }
                if (target.classList.contains('pswp__button--arrow--prev')) {
                    glide.go('<');
                }
            })
        });

        glide.mount();
    });
})();
